export default __webpack_public_path__ + "static/media/Apoorva Nagar.0d8bc4d1.png";